import { formatIsoDate } from './dateUtils';

const CSV_SEPARATOR = ';';
const CSV_LINE_BREAK = '\r\n';
const CSV_BOM = '\uFEFF';

const needsQuotes = (text) => (
    text.includes(CSV_SEPARATOR) ||
    text.includes('"') ||
    text.includes('\n') ||
    text.includes('\r')
);

export const escapeCsvValue = (value) => {
    if (value === null || value === undefined) return '';

    const text = String(value);

    return needsQuotes(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

export const buildCsvLine = (values) => values.map(escapeCsvValue).join(CSV_SEPARATOR);

export const getColumnCsvValue = (column, row) => {
    const rawValue = row[column.field];

    if (column.csvFormatter) return column.csvFormatter(rawValue, row);

    const value = column.valueGetter ? column.valueGetter(rawValue, row, column) : rawValue;

    return column.valueFormatter ? column.valueFormatter(value, row, column) : value;
};

export const buildCsvContent = (columns, rows) => {
    const header = buildCsvLine(columns.map((column) => column.headerName ?? column.field));
    const body = rows.map((row) => buildCsvLine(columns.map((column) => getColumnCsvValue(column, row))));

    return CSV_BOM + [header, ...body].join(CSV_LINE_BREAK) + CSV_LINE_BREAK;
};

export const buildCsvFileName = (baseName) => `${baseName}-${formatIsoDate(new Date())}.csv`;

export const downloadBlob = (fileName, blob) => {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');

    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};

export const downloadCsvContent = (fileName, content) => downloadBlob(
    fileName,
    new Blob([content], { type: 'text/csv;charset=utf-8;' })
);

export const exportRowsToCsv = ({ baseName, columns, rows }) => {
    downloadCsvContent(buildCsvFileName(baseName), buildCsvContent(columns, rows));
};
